var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424 0H24C10.75 0 0 10.75 0 24S10.75 48 24 48H424C437.25 48 448 37.25 448 24S437.25 0 424 0ZM224 96C126.799 96 48 174.797 48 272V336C48 433.203 126.799 512 224 512C321.203 512 400 433.203 400 336V272C400 174.797 321.203 96 224 96ZM352 336C352 406.58 294.58 464 224 464C153.422 464 96 406.58 96 336V272C96 201.42 153.422 144 224 144C294.58 144 352 201.42 352 272V336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverline);
export default __webpack_public_path__ + "static/media/overline.6d180d4874fdd2cde3dd8761312358e7.svg";
export { ForwardRef as ReactComponent };